<template>
  <div style="margin-bottom: 10px">
    <el-card class="box-card">
      <el-form label-width="100px">
        <el-form-item label="邮件模板ID：">
          <el-input
            style="width: 80px"
            size="mini"
            v-model="data.mailTemplateId"
          ></el-input>
        </el-form-item>
        <el-form-item style="margin-top: 10px" label="奖励：">
          <base-item-selector
            @updated="updatedItemSelector"
            v-model="data.reward"
          ></base-item-selector>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import BaseItemSelector from "./biz-components/BaseItemSelector";

export default {
  data() {
    return {
      data: {
        mailTemplateId: "",
        reward: [],
      },
      rewardsItemResult: {},
    };
  },
  components: {
    BaseItemSelector,
  },

  watch: {
    data: {
      async handler() {
        await this.updatedParam();
      },
      deep: true,
    },
  },

  async created() {
    await this.loadConfig();
    if (this.parameter) {
      this.data = JSON.parse(this.parameter);
    }
  },

  props: {
    parameter: "",
  },

  methods: {
    async loadConfig() {},
    async updatedItemSelector(param) {
      this.rewardsItemResult = param;
      if (!this.rewardsItemResult.errMsg) {
        this.data.reward = JSON.parse(JSON.stringify(this.rewardsItemResult));
        await this.updatedParam();
      }
    },
    async updatedParam() {
      this.data.mailTemplateId = this.data.mailTemplateId.trim();
      this.$emit("updated", JSON.stringify(this.data), async () => {
        if (this.rewardsItemResult.errMsg) {
          return { errMsg: this.rewardsItemResult.errMsg };
        }

        let rewards = this.rewardsItemResult;

        if (rewards.length == 0) {
          return { errMsg: "奖励最少配置一项" };
        }

        if (!this.data.mailTemplateId.trim()) {
          return { errMsg: "邮件模板id不能为空" };
        }

        return;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.link-button {
  padding-left: 5px;
  padding-right: 5px;
  color: rgb(37, 148, 240);

  cursor: pointer;
}

::v-deep .el-table__row td {
  padding: 0px 0;
}

.el-table .cell.el-tooltip {
  white-space: normal;
}
</style>